import { ReactNode } from 'react';
import { FiActivity, FiCalendar, FiCreditCard, FiGrid, FiLayers, FiLogOut, FiSettings, FiShoppingBag } from 'react-icons/fi';
import { NavLink, useNavigate } from 'react-router-dom';

import { useAdmin } from '../contexts/AdminAuthContext';

const NAV = [
  { to: '/admin', label: 'Dashboard', icon: <FiGrid />, end: true },
  { to: '/admin/shops', label: 'Shops', icon: <FiShoppingBag /> },
  { to: '/admin/subscriptions', label: 'Subscriptions', icon: <FiCreditCard /> },
  { to: '/admin/shop-types', label: 'Shop types', icon: <FiLayers /> },
  { to: '/admin/festivals', label: 'Festival calendar', icon: <FiCalendar /> },
  { to: '/admin/audit', label: 'Audit log', icon: <FiActivity /> },
  { to: '/admin/settings', label: 'Platform settings', icon: <FiSettings /> },
];

export default function AdminLayout({ children }: { children: ReactNode }) {
  const { admin, logout } = useAdmin();
  const navigate = useNavigate();
  return (
    <div className="flex h-full">
      <aside className="flex w-60 flex-col bg-indigo-950 text-indigo-100">
        <div className="border-b border-indigo-900 px-4 py-4">
          <div className="text-lg font-bold text-white">Zentrix POS</div>
          <div className="text-sm text-indigo-300">Super Admin</div>
        </div>
        <nav className="flex-1 py-2">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end}
              className={({ isActive }) => `flex items-center gap-3 px-4 py-2.5 ${isActive ? 'bg-indigo-700 text-white' : 'hover:bg-indigo-900'}`}>
              {n.icon}{n.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-indigo-900 p-3 text-sm">
          <NavLink to="/admin/profile" className="block text-white hover:underline" title="My profile">{admin?.full_name || admin?.username}</NavLink>
          <NavLink to="/admin/profile" className="mt-1 block text-indigo-300 hover:text-white">My profile · change password</NavLink>
          <button className="mt-2 flex items-center gap-2 text-indigo-300 hover:text-white"
            onClick={() => { logout(); navigate('/admin/login'); }}><FiLogOut /> Sign out</button>
        </div>
      </aside>
      <main className="min-w-0 flex-1 overflow-y-auto p-6">{children}</main>
    </div>
  );
}
